"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ComponentWrapper = _interopRequireDefault(require("../../new-components/helpers/ComponentWrapper"));
var _Link = _interopRequireDefault(require("../../new-components/Link/Link"));
var _Svg = _interopRequireDefault(require("../../new-components/Svg/Svg"));
var BookingFooter = function BookingFooter(_ref) {
  var navigationLinks = _ref.navigationLinks,
    paymentOptions = _ref.paymentOptions;
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement("footer", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-gap-md"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-6@sm"
  }, navigationLinks.map(function (link) {
    return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      className: "margin-top-md text-sm d8-u-color-contrast-medium margin-right-md block inline@sm",
      href: link.href,
      key: link.href,
      external: link.external
    }, /*#__PURE__*/_react["default"].createElement("strong", null, link.label));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-6@sm text-right@sm flex items-center justify-end@sm"
  }, paymentOptions.visa && /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "visa",
    className: "margin-right-sm"
  }), paymentOptions.mastercard && /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "mastercard",
    className: "margin-right-sm"
  }), paymentOptions.amex && /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "amex",
    className: "margin-right-sm"
  }), paymentOptions.applePay && /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "apple-pay-mark",
    className: "icon--lg margin-right-xxxs"
  }), paymentOptions.googlePay && /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "google-pay-mark",
    className: "icon--lg"
  })))));
};
BookingFooter.propTypes = {
  navigationLinks: _propTypes["default"].array,
  paymentOptions: _propTypes["default"].object
};
var _default = exports["default"] = BookingFooter;